module.exports = __webpack_public_path__ + "assets/img/icon1-menu2.c9e8cece.svg";